<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="subject">{{subject.name}}</template><template v-if="subject && subject.unit">(单位:{{subject.unit}})</template> - 明细账 </span>
		</div>
		<div class="margin-right-left margin-top">
			<div class="book-toolbar">
				<div class="book-toolbar-main">
					<div class="book-toolbar-period">
						<account-date-choose v-model="periodRange" :range="true"/>
					</div>
					<div class="book-toolbar-actions">
						<Checkbox v-if="amountMode === 'base'" v-model="showOppositeSubject" class="book-inline-checkbox">按对方科目展开</Checkbox>
						<Button type="primary" @click="exportData">导出</Button>
						<Checkbox v-if="amountMode === 'base'" :disabled="numPriceDisabled" v-model="showNumPrice" class="book-inline-checkbox">显示数量金额</Checkbox>
					</div>
				</div>
				<div class="book-toolbar-filters">
					<div class="book-filter-group">
						<label class="book-filter-label">金额方式</label>
						<Select
							v-model="amountMode"
							:datas="amountModeOptions"
							keyName="key"
							titleName="title"
							:deletable="false"
							class="book-filter-select mode-select"
						/>
					</div>
					<div class="book-filter-group" v-if="amountMode === 'foreign'">
						<label class="book-filter-label">币种</label>
						<template v-if="!noForeignCurrency">
							<Select
								v-model="currencyCode"
								:datas="currencyOptions"
								keyName="key"
								titleName="title"
								filterable
								:deletable="false"
								class="book-filter-select currency-select"
							/>
						</template>
						<span v-else class="book-filter-hint">当前账套无可用外币，请先配置外币</span>
					</div>
				</div>
			</div>
		</div>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1" style="overflow-x: auto;">
				<Loading text="明细账数据加载中..." :loading="loading"></Loading>

				<!-- 本币模式 - 普通表格 -->
				<table class="cus-table" v-if="amountMode === 'base' && !showNumPrice">
					<thead class="header">
					<tr>
						<td>日期</td>
						<td>凭证字号</td>
						<td>科目</td>
						<td v-if="showOppositeSubject">对方科目</td>
						<td>摘要</td>
						<td>借方</td>
						<td>贷方</td>
						<td v-if="!showOppositeSubject">方向</td>
						<td v-if="!showOppositeSubject">余额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.detailsId">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td>{{item.subjectName}}</td>
						<td v-if="showOppositeSubject">{{item.oppositeSubjectName}}</td>
						<td>{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td v-if="!showOppositeSubject" class="text-center">{{item.balanceDirection}}</td>
						<td v-if="!showOppositeSubject" class="text-right">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td :colspan="showOppositeSubject ? 7 : 8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>

				<!-- 本币模式 - 数量金额表格 -->
				<table class="cus-table" :style="showOppositeSubject ? 'width: 1200px;' : 'width: 1550px;'" v-if="amountMode === 'base' && showNumPrice">
					<thead class="header">
					<tr>
						<td rowspan="2" width="100">日期</td>
						<td rowspan="2" width="100">凭证字号</td>
						<td rowspan="2" width="150">科目</td>
						<td rowspan="2" width="200" v-if="showOppositeSubject">对方科目</td>
						<td rowspan="2" width="200">摘要</td>
						<td colspan="3">借方发生额</td>
						<td colspan="3">贷方发生额</td>
						<td colspan="4" v-if="!showOppositeSubject">余额</td>
					</tr>
					<tr>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
						<td width="100" v-if="!showOppositeSubject">方向</td>
						<td width="100" v-if="!showOppositeSubject">数量</td>
						<td width="100" v-if="!showOppositeSubject">单价</td>
						<td width="100" v-if="!showOppositeSubject">金额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.detailsId">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td class="nowrap">{{item.subjectName}}</td>
						<td class="nowrap" v-if="showOppositeSubject">{{item.oppositeSubjectName}}</td>
						<td class="nowrap">{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.num:''}}</td>
						<td class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.price:''}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.num:''}}</td>
						<td class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.price:''}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center" v-if="!showOppositeSubject">{{item.balanceDirection}}</td>
						<td class="text-right" v-if="!showOppositeSubject">{{item.numBalance|numFormat}}</td>
						<td class="text-right" v-if="!showOppositeSubject">{{item.price|numFormat}}</td>
						<td class="text-right" v-if="!showOppositeSubject">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td :colspan="showOppositeSubject ? (showNumPrice ? 9 : 7) : (showNumPrice ? 12 : 8)" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>

				<!-- 外币模式表格 -->
				<table class="cus-table foreign-table" v-if="amountMode === 'foreign'" style="width:1500px;">
					<thead class="header">
					<tr>
						<td width="90">日期</td>
						<td width="100">凭证字号</td>
						<td width="150">科目</td>
						<td width="180">摘要</td>
						<td width="80">币种</td>
						<td width="110">原币借方</td>
						<td width="110">原币贷方</td>
						<td width="110">原币余额</td>
						<td width="110">本币借方</td>
						<td width="110">本币贷方</td>
						<td width="55">方向</td>
						<td width="110">本币余额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.detailsId || item.summary">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td>{{item.subjectName}}</td>
						<td>{{item.summary}}</td>
						<td class="text-center">
							<span v-if="item.currencyCode" class="currency-badge">{{item.currencyCode}}</span>
						</td>
						<td class="text-right">{{formatOrigin(item.originalDebitAmount)}}</td>
						<td class="text-right">{{formatOrigin(item.originalCreditAmount)}}</td>
						<td class="text-right">{{formatOrigin(item.originalBalance)}}</td>
						<td class="text-right">{{formatBase(item.debitAmount)}}</td>
						<td class="text-right">{{formatBase(item.creditAmount)}}</td>
						<td class="text-center">{{item.balanceDirection || ''}}</td>
						<td class="text-right">{{formatBase(item.balance)}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td colspan="12" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</Cell>
			<Cell v-width="200">
				<Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
	import accountBookPeriodRange from '@/mixins/accountBookPeriodRange'

	export default {
		name: 'DetailedAccounts',
		mixins: [accountBookPeriodRange],
		data() {
			return {
				loading: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				datalist: [],
				subjectId: null,
				showNumPrice: false,
				numPriceDisabled: true,
				periodRange: {
					startDate: null,
					endDate: null
				},
				subject: null,
				showOppositeSubject: false,
				amountMode: 'base',
				currencyCode: '',
				currencyList: [],
				noForeignCurrency: false    // 是否没有任何非本位币
			};
		},
		computed: {
			amountModeOptions() {
				return [
					{key: 'base', title: '本币金额方式'},
					{key: 'foreign', title: '外币金额方式'}
				];
			},
			currencyOptions() {
				const baseCurrency = this.getBaseCurrency;
				const filtered = (this.currencyList || []).filter(item => !item.localCurrency);
				if (filtered.length === 0) {
					return [];
				}
				return filtered.map(item => ({
					key: item.code,
					title: `${item.code} - ${item.name || item.code}`
				}));
			},
			getBaseCurrency() {
				const list = this.currencyList || [];
				const base = list.find(item => item.localCurrency);
				return base ? base.code : '';
			},
		},
		watch: {
			subject() {
				let org = this.showNumPrice;
				if (this.subject.unit) {
					this.numPriceDisabled = false;
					this.showNumPrice = true;
				} else {
					this.showNumPrice = false;
				}
				if (org == this.showNumPrice) {
					this.loadList();
				}
			},
			showNumPrice() {
				this.loadList();
			},
			showOppositeSubject() {
				this.loadList();
			},
			periodRange: {
				handler() {
					if (!this.accountBookPeriodRangeReady) {
						return;
					}
					this.loadSubject();
				},
				deep: true
			},
			amountMode(newVal) {
				if (newVal === 'foreign') {
					const baseCurrency = this.getBaseCurrency;
					const foreignCurrencies = (this.currencyList || []).filter(item => !item.localCurrency);
					if (foreignCurrencies.length === 0) {
						this.noForeignCurrency = true;
						this.currencyCode = '';
						this.datalist = [];
						return;
					}
					this.noForeignCurrency = false;
					const validCodes = foreignCurrencies.map(c => c.code);
					if (!this.currencyCode || !validCodes.includes(this.currencyCode)) {
						this.currencyCode = foreignCurrencies[0].code;
					}
					if (this.subjectId) {
						this.loadList();
					}
				} else {
					this.noForeignCurrency = false;
					this.currencyCode = '';
					this.datalist = [];
					if (this.subjectId) {
						this.loadList();
					}
				}
			},
			currencyCode() {
				if (this.amountMode === 'foreign' && this.subjectId) {
					this.loadList();
				}
			}
		},
		methods: {
			onAccountBookPeriodRangeReady() {
				this.loadCurrencyList();
				this.loadSubject();
			},
			buildRangeParams() {
				return {
					startDate: this.periodRange.startDate,
					endDate: this.periodRange.endDate
				};
			},
			loadCurrencyList() {
				if (this.$api.setting && this.$api.setting.currency) {
					this.$api.setting.currency.list().then(({data}) => {
						this.currencyList = Array.isArray(data) ? data : (data.data || []);
					}).catch(() => {});
				}
			},
			loadSubject() {
				this.datalist = [];
				this.$api.accountbook.loadSubject(this.buildRangeParams()).then(({data}) => {
					this.$set(this.param, "datas", data);
					if (data.length) {
						this.subjectId = data[0].id;
						this.subject = data[0];
					}
				});
			},
			loadList() {
				this.loading = true;

				if (this.amountMode === 'foreign') {
					this.$api.accountbook.loadVoucherDetails({
						...this.buildRangeParams(),
						subjectId: this.subjectId,
						subjectCode: this.subject ? this.subject.code : '',
						amountMode: 'foreign',
						currencyCode: this.currencyCode || ''
					}).then(({data}) => {
						this.datalist = data;
						this.loading = false;
					});
					return;
				}

				let apiCall;
				if (this.showOppositeSubject) {
					apiCall = this.$api.accountbook.loadVoucherDetailsByOppositeSubject({
						...this.buildRangeParams(),
						subjectId: this.subjectId
					});
				} else {
					apiCall = this.$api.accountbook.loadVoucherDetails({
						...this.buildRangeParams(),
						subjectId: this.subjectId,
						showNumPrice: this.showNumPrice,
						subjectCode: this.subject ? this.subject.code : ''
					});
				}

				apiCall.then(({data}) => {
					this.datalist = data;
					this.loading = false;
				});
			},
			subjectSelect(node) {
				this.subject = node;
			},
			formatOrigin(val) {
				if (val === null || val === undefined) return '';
				if (Math.abs(val) < 0.001) return '';
				return this.$options.filters.numFormat(val);
			},
			formatBase(val) {
				if (val === null || val === undefined) return '';
				return this.$options.filters.numFormat(val);
			},
			exportData() {
				const params = {
					...this.buildRangeParams(),
					subjectId: this.subjectId,
					subjectCode: this.subject ? this.subject.code : '',
					showNumPrice: this.showNumPrice,
					amountMode: this.amountMode,
					currencyCode: this.amountMode === 'foreign' ? (this.currencyCode || '') : ''
				};
				window.open(`/api/accountbook/export/details?${new URLSearchParams(params).toString()}`);
			}
		}
	};
</script>

<style scoped lang="less">
	.book-toolbar {
		padding: 14px 16px;
		background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);
		border: 1px solid #dbe7f3;
		border-radius: 10px;
		box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
	}

	.book-toolbar-main {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 12px;
	}

	.book-toolbar-period {
		flex: 1 1 320px;
		min-width: 280px;
	}

	.book-toolbar-actions {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;
		justify-content: flex-end;
	}

	.book-toolbar-filters {
		margin-top: 12px;
		padding-top: 12px;
		border-top: 1px dashed #d7e2ee;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 16px;
	}

	.book-filter-group {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.book-filter-label {
		font-size: 13px;
		color: #516173;
		font-weight: 600;
		white-space: nowrap;
	}

	.book-inline-checkbox {
		white-space: nowrap;
	}

	.book-filter-select {
		min-width: 180px;
	}

	.currency-select {
		min-width: 220px;
	}

	.foreign-table {
		min-width: 1500px;
	}

	.currency-badge {
		display: inline-block;
		background-color: #dbeafe;
		color: #1d4ed8;
		border-radius: 3px;
		padding: 1px 6px;
		font-size: 11px;
		font-weight: 600;
		border: 1px solid #c3d4f8;
		line-height: 1.2;
	}

	.book-filter-hint {
		color: #999;
		font-size: 12px;
		font-style: italic;
	}
	@media (max-width: 1200px) {
		.book-toolbar-actions {
			justify-content: flex-start;
		}
	}
</style>
